import { observer } from "mobx-react";
import {Carousel} from "react-bootstrap";
import archivosStore from "../stores/ArchivosStore";

function _CarouselDesktop() {
    return (
        <Carousel interval={2000} className="carousel  px-0 maincarousel" fade={true}>
            { archivosStore.bannersDesktop.map(img =>
                <Carousel.Item key={img.id}>
                    <img style={{width: '100%', margin: 'auto'}} alt='' src={img.url} className="d-block w-100"/>
                </Carousel.Item>
            )}
        </Carousel>
    );
}
export const CarouselDesktop = observer(_CarouselDesktop);


export function _CarouselMobile() {
    return (
        <Carousel interval={2500} className="carousel px-0 maincarousel" fade={true}>
            { archivosStore.bannersMobile.map(img =>
                <Carousel.Item>
                    <img alt='' src={img.url} className="d-block w-100"/>
                </Carousel.Item>
            )}
        </Carousel>
    );
}
export const CarouselMobile = observer(_CarouselMobile);
